export default "__VITE_ASSET__CZ_vVH4i__"